import { NgModule } from '@angular/core';

import { HttpService } from './http.service';
import { BaseService } from './base.service';
import { AccountService } from './account.service';
import { EnvironmentService } from '../environment/environment.service';
import { AuthService } from './auth.service';
import { PrincipalService } from './principal.service';

@NgModule({
  providers: [
    HttpService,
    BaseService,
    EnvironmentService,
    AccountService,
    AuthService,
    PrincipalService
  ],
})
export class ServicesModule {}
